import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

import autocomplete from "lib/autocomplete"
import AcademicTitles from "lib/academic_titles"

// Lists that can be named as a source instead of a URL.
const LISTS = {
  "academic-titles": AcademicTitles.list,
}

// Suggests values in a free-text field, from a named list or a JSON endpoint.
// A chosen item fills the field with its `key` property (or the item itself,
// for a list of strings). lib/autocomplete has no teardown (each call adds a
// menu and a document listener), so an input is only set up once, even if the
// controller reconnects.
export default class extends Controller {
  static values = {
    source: String,
    key: { type: String, default: "label" },
    openOnFocus: Boolean,
  }

  connect() {
    const input = $(this.element)
    if (input.data("autocomplete")) return

    const key = this.keyValue

    autocomplete(input, {
      source: LISTS[this.sourceValue] || this.sourceValue,
      autoFocus: this.openOnFocusValue,
      select(event, ui) {
        event.preventDefault()
        return this.val(typeof ui.item === "string" ? ui.item : ui.item[key])
      },
    })
  }
}
